angular.module('dnecom')
    .controller('CartsController', ["$scope", "wizardModal", "$http", "$timeout", "notifications", "StoreUtils", "DTOptionsBuilder", function CartsController($scope, wizardModal, $http, $timeout, notifications, StoreUtils, DTOptionsBuilder) {

        $scope.currentStore = TemplateData.value('store');
        $scope.timezoneOffset = TemplateData.value('timezoneOffset');

        $scope.loading = false;
        $scope.filtersVisible = false;
        $scope.selectedStatus = 'open';
        $scope.activeProductList = null;
        $scope.copy = [];
        $scope.page = 0;
        $scope.pageSize = 15;
        $scope.order = {column: "updatedAt", dir: "desc"};
        $scope.sortableColumns = {};
        $scope.filters = {
            phrase: "",
            dateFrom: "",
            dateTo: ""
        };

        $scope.tableInstance = {
            displayLength: 15,
            pages: {
                current: 1
            }
        };

        $scope.dtCartsTableOptions =  DTOptionsBuilder.newOptions()
            .withOption('aaSorting', [[3, 'desc']]);

        $scope.dtCartsColumnDefs = [
            {
                targets: 'col-hidden',
                visible: false
            },
            {
                targets: 'col-unorderable',
                orderable: false
            }
        ];

        
        $scope.init = function () {
            $scope.load();
        };

        $scope.getSourceIcon = function (transaction) {
            var storeType = transaction.storeType;
            if (storeType) {
                if (storeType == 'main') {
                    return 'fa fa-desktop';
                } else if (storeType == 'mobile') {
                    return 'fa fa-mobile';
                }
            }
            return false;
        };

        $scope.showProductsList = function (id) {
            $scope.activeProductList = id;
        };

        $scope.hideProductsList = function () {
            $scope.activeProductList = null;
        };

        $scope.changeStatus = function (status) {
            $scope.selectedStatus = status;
            $scope.setPage(1);
        };

        $scope.load = function () {

            $scope.loading = true;

            $http.post(
                Routing.generate('carts_get', {id: $scope.currentStore.id}),
                {
                    filter: $scope.filters,
                    status: $scope.selectedStatus,
                    order: $scope.order,
                    start: ($scope.tableInstance.pages.current - 1),
                    length: $scope.pageSize
                })
                .success(function (response) {
                    if (!response.hasOwnProperty('data') || !response.data.hasOwnProperty('carts')) {
                        if (response && response.data !== undefined && response.data.message !== undefined) {
                            notifications.danger(response.data.message);
                        } else {
                            notifications.danger('Server error, please refresh the page');
                        }

                        return;
                    }

                    $scope.carts = response.data.carts;
                    $scope.copy = $scope.carts;
                    $scope.count = response.data.filtered;
                })
                .finally(function () {
                    $timeout(function () {
                        $scope.$emit('datatable.updated');
                        calcViewPages($scope.count);
                        $scope.loading = false;
                    });
                });
        };

        $scope.generateCartUrl = function(cart) {
            return StoreUtils.generateRoute(TemplateData.value('store'), 'stores_fe_cart', {'hash': cart.hash}, true);
        };

        $scope.clear = function () {
            $scope.filters.dateFrom = "";
            $scope.filters.dateTo = "";

            $scope.setPage(1);
            $scope.load();
        };

        $scope.applyDateFilter = function () {
            $scope.setPage(1);
            $scope.load();
        };

        $scope.search = function () {
            $scope.setPage(1);
            $scope.load();
        }

        $scope.setOrder = function (columnName) {
            if ($scope.order.column == columnName) {
                if ($scope.order.dir == 'desc') {
                    $scope.order.dir = 'asc';
                } else {
                    $scope.order.dir = 'desc';
                }
            } else {
                $scope.order = {column: columnName, dir: "desc"};
            }
            $scope.setPage(1);
            $scope.load();
        };

        $scope.openExportModal = function () {
            var exportModal = wizardModal.open({
                'templateUrl': 'cartExportModal.html',
                'controller': 'CartExportModalController',
                'size': 'md',
                'resolve': {
                    'storeId': function () {
                        return $scope.currentStore.id;
                    },
                    'parameters': function () {
                        return {
                            filter: $scope.filters,
                            status: $scope.selectedStatus,
                            order: $scope.order,
                            start: $scope.page,
                            length: $scope.pageSize
                        };
                    }
                }
            });
        };

        $scope.onSuccess = function (e) {
            notifications.success('Cart URL was successfully copied to clipboard!');
        };

        var updateViewPagesFromTo = function () {
            $scope.tableInstance.pages.from =  ($scope.tableInstance.pages.current - 1) * $scope.tableInstance.displayLength + 1;
            $scope.tableInstance.pages.to =  $scope.tableInstance.pages.from + $scope.tableInstance.displayLength - 1;

            if ($scope.tableInstance.pages.to > $scope.tableInstance.pages.size) {
                $scope.tableInstance.pages.to = $scope.tableInstance.pages.size;
            }
        };

        var calcViewPages = function (count) {
            $scope.tableInstance.pages.size = parseInt(count);

            if ($scope.tableInstance.displayLength === -1) {
                $scope.tableInstance.displayLength = $scope.tableInstance.pages.size;
            }

            $scope.tableInstance.pages.max = Math.max(1, Math.ceil($scope.tableInstance.pages.size / $scope.tableInstance.displayLength));

            if (typeof $scope.tableInstance.pages.current === 'undefined') {
                $scope.tableInstance.pages.current = 1;
            }

            if ($scope.tableInstance.pages.current > $scope.tableInstance.pages.max) {
                $scope.tableInstance.pages.current = $scope.tableInstance.pages.max;
            }

            updateViewPagesFromTo();
        };

        $scope.nextPage = function () {
            var pages = $scope.tableInstance.pages;
            $scope.tableInstance.pages.current = (pages.current === pages.max) ? pages.max : pages.current + 1;
            $scope.load();
        };

        $scope.prevPage = function () {
            var pages = $scope.tableInstance.pages;
            $scope.tableInstance.pages.current = (pages.current === 1) ? 1 : pages.current - 1;
            $scope.load();
        };

        $scope.setPage = function (page) {
            $scope.tableInstance.pages.current = page;
            $scope.load();
        };
    }])
    .filter('timestamp', function () {
        return function (dateString) {
            return moment(dateString).unix();
        }
    });
